import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_COST_PROVIDER_ID_LOADING = 'GET_COST_PROVIDER_ID_LOADING';
export const GET_COST_PROVIDER_ID_SUCCESS = 'GET_COST_PROVIDER_ID_SUCCESS';
export const GET_COST_PROVIDER_ID_REJECT = 'GET_COST_PROVIDER_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getCostProviderIdLoading = () => ({ type: GET_COST_PROVIDER_ID_LOADING });
export const getCostProviderIdSuccess = (payload) => ({ type: GET_COST_PROVIDER_ID_SUCCESS, payload });
export const getCostProviderIdReject = (payload) => ({ type: GET_COST_PROVIDER_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getCostProviderIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/CostProviders/${id}/edit`, options);
};